import configurations from "./environments"

const environment = import.meta.env?.VITE_REACT_APP_ENV || process.env.REACT_ENV || "local"
console.log("environment", { environment, en: import.meta.env, pen: process.env })
const config = configurations[environment as keyof typeof configurations]
if (!config) throw `Configuration not found for environment: ${environment}`

export default {
  ...config,
  name: environment
}
